import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";

const AppCollectionManager = () => {
    const navLinks = [
        {destination: "/icr", label: "Requirements", activePrefixes: ["/icr"]},
        {destination: "/collection/tasks", label: "Collection", activePrefixes: ["/collection"]},
        {destination: "charts", label: "Charts"},
        {destination: "feed", label: "Feeds"},
        {destination: "kb", label: "KB"},
        {destination: "workflow", label: "Workflow"},
        HELP_NAV_LINK,
    ];

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks}/>
            <Stack flex={1} overflow={'auto'}>
                <Outlet/>
            </Stack>
        </Stack>
    );
};

export default AppCollectionManager;

